import axios from "axios";

/* create axios factory */
let http = axios.create({
  baseURL: process.env.VUE_APP_API_V1_URL,
  timeout: 500000000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; multipart/form-data",
    "Accept-Language" : "pt-BR"
  },
  handleError: true
});

/* handle default response  */
// http.interceptors.response.use(
//   response => response,
//   error => {
//     // Vue.prototype.$snackbar = {show: true, color: 'error', text: 'ERRRO'}
//     // if (error.response.status === 403) {
//     //   localStorage.clear()
//     // }
//     return Promise.reject(error);
//   }
// );

export default http;
